module.exports = __webpack_public_path__ + "assets/img/mecha-active-btn-126c19be.png";